/**
 * @Description
 */
import { FC, ReactNode } from 'react';
import styles from './index.module.less';
import cs from 'classnames';

interface PageTitleProps {
  content?: ReactNode | string; // 左侧显示标题
  customizeContent?: ReactNode | string; // 左侧自定义标题，会优先展示
  tabs?: ReactNode; // 左侧显示tabs
  extra?: ReactNode;
}

const PageTitle: FC<PageTitleProps> = ({
  content,
  customizeContent,
  tabs,
  extra
}) => {
  return <>
    <div className={cs(styles.titleOperate, !tabs && styles.content)}>
      {customizeContent || tabs || content}
      {extra}
    </div>
    <span className={styles.line} />
  </>;
};
export default PageTitle;
